<template>
  <div id="active-reports" class="active-reports" style="height: 100vh" v-if="gcsSignInSheetTemplate!=''">
    <!-- <div class="download-button-section">
      <button class="btn btn-primary downlad-report-button" @touchstart="downloadReport" @click="downloadReport">Download As PDF</button>
    </div> -->
    <GcArViewer
      theme="ActiveReports"
      ref="reportViewer"
      :availableExports="availableExports"
      :sidebarVisible="true"
      @viewerLoaded="onViewerLoaded"
    ></GcArViewer>

    <!-- #1533: in-viewer assign modal, opened when a wishlist-summary report's
         per-row employee link is clicked. Stays inside this viewer (no new tab,
         no parent window); calls the cs3 API with the token already on the URL. -->
    <div v-if="assignModalOpen" class="wla-overlay" @click.self="closeAssignModal">
      <div class="wla-modal">
        <div class="wla-head">
          <h3 class="wla-title">Assign open slot</h3>
          <button type="button" class="wla-close" @click="closeAssignModal">&times;</button>
        </div>

        <div v-if="assignError" class="wla-error">{{ assignError }}</div>
        <div v-if="assignSuccess" class="wla-success">{{ assignSuccess }}</div>

        <div v-if="assignLoading" class="wla-note">Loading open slots…</div>
        <div v-else-if="assignSlots.length === 0 && !assignError" class="wla-note">
          No open slots this employee is skilled for.
        </div>

        <ul v-else class="wla-slots">
          <li v-for="slot in assignSlots" :key="slot.id" class="wla-slot">
            <span class="wla-slotinfo">
              <strong>{{ slot.skill || 'No required skill' }}</strong>
              <em>{{ formatSlot(slot) }}</em>
            </span>
            <button type="button"
                    class="wla-btn"
                    :class="{ 'is-busy': assigningId === slot.id }"
                    :disabled="assigningId === slot.id"
                    @click="assignSlot(slot)">
              {{ assigningId === slot.id ? '…' : 'Assign' }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import '@grapecity/activereports';
import { Viewer as ReportViewer } from '@grapecity/activereports-vue';
import "@grapecity/activereports/styles/ar-js-ui.css";
import "@grapecity/activereports/styles/ar-js-viewer.css";
// import { saveAs } from 'file-saver';

import { Core } from "@grapecity/activereports"; 
Core.setLicenseKey("reports.callsteward.ca|reports.callsteward.com|reports.callsteward.net,516284612545651#B1mFfNFUerh6ca3UarAHWyczVNB5MwoWMadXRUZGepBFarxGStNkQxNFNmFEMvhEWCl4dJFHUNBlVJpVYIJ7YJZ6KFVTbstUbENFV5ADR8VlY8J4aIJDcqxmNLhUcmdkMUxUaBdnVq34MqF7dvITeZpGdqFnMMpXOrN5ZOdVMaZFa7ljSBJFcwoEZDtSQysST9gHVUJnSpFDMUxmeVlnMHl7RyQDOItkQ4kzZllUdnVnQ6U7SzhUdBBjNBZVRxd5S5JXQWpkNBFGMwdneOVlN9ZzT43UMRljcNJzLXJ5QjVVZrp6bXZ5bMVXNqhUUsRnVtFXZtp4RuZHWlZUWyokUVlGODR4ZylGSvlXZkNmI0IyUiwiI6QzQ9MjM4IjI0ICSiwSNycjN4ETO6kTM0IicfJye&Qf35VfiQlRWllI0IyQiwiI4YFITpEdy3GclJVZ6lGdjFkI0IiTis7W0ICZyBlIsISM4YTMzADI5ITNwMjMwIjI0ICdyNkIsICdl9mLkJXY7VGdzxGbhNmLzRncvBXZyxSbvNmLkJXY7VGdzxGbhNmLzRncvBXZyxSYj9CZyF6dlR7csxWYj9yc4J7bwVmciojIz5GRiwiIkJXY7VGdTBCbsF6QiojIh94QiwiIxUjN5QTNyEjN4gjM6ETNiojIklkIs4XXbpjInxmZiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TU4ZVea3GZkFEdXVGcvRjaYJUZE9mb59UTRNlT6gVRsVjYpBzKzYEe0tkQyk4SSpkRjpENXRTSyVlS4gTW8NmcaZTTJR7L8l5vh");

export default {
    components: {
        GcArViewer: ReportViewer
    },

  data() {
    return {
      token: '',
      employee_id: '',
      loadingReport: false,
      gcsSignInSheetTemplate: '',
      job_id: '',
      api_base_url: '',
      // #1533: saved reference so we can restore the native window.open on teardown
      origWindowOpen: null,
      // #1533: in-viewer wishlist-assign modal state
      assignModalOpen: false,
      assignJob: '',
      assignEmployee: '',
      assignSlots: [],
      assignLoading: false,
      assigningId: null,
      assignError: '',
      assignSuccess: '',
      dataSource: '',
      tempReportJsonUrl: '',
      reportDocument: null,
      checkDocumentInterval: null,
      availableExports: ['pdf','xlsx','html','tabular-data'],
      exportsSettings: {
        pdf: {
          title: "Employee Report",
          filename: "EmployeeReport.pdf",
          author: "Callsteward",
          subject: "Web Reporting",
          keywords: "reporting, sample",
          printing: false,
          copying: false,
          modifying: false,
          annotating: false,
          contentAccessibility: false,
          documentAssembly: false,
          pdfVersion: "1.3",
          autoPrint: false
        },
        xlsx: {
          title: "EmployeeReport",
          filename: "EmployeeReport.xlsx",
          author: "Callsteward",
          subject: "Web Reporting",
          keywords: "reporting, sample",
          printing: false,
          copying: false,
          modifying: false,
          annotating: false,
          contentAccessibility: false,
          documentAssembly: false,
          pdfVersion: "1.3",
          autoPrint: false
        },
        html: {
          title: "EmployeeReport",
          filename: "EmployeeReport.html",
          author: "Callsteward",
          subject: "Web Reporting",
          keywords: "reporting, sample",    
          printing: false,
          copying: false,
          modifying: false,
          annotating: false,
          contentAccessibility: false,
          documentAssembly: false,
          pdfVersion: "1.3",
          autoPrint: false
        }
      },
    };
  },

  computed: {
    reportZoom() {
      return window.innerWidth > 1367 ? 150 : 100;
    },
  },

  async mounted() {
    this.gcsSignInSheetTemplate = atob(this.$route.params.url);
    this.token = this.$route.query.token && this.$route.query.token !== '' 
                      ? "Bearer " + atob(this.$route.query.token) 
                      : '';
    this.dataSource = this.$route.query.data_source && this.$route.query.data_source !== '' 
                      ? atob(this.$route.query.data_source) 
                      : '';
    this.employee_id = this.$route.query.employee && this.$route.query.employee !== '' 
                      ? atob(this.$route.query.employee) 
                      : '';
    this.job_id = this.$route.query.job && this.$route.query.job !== '' 
                      ? atob(this.$route.query.job) 
                      : '';
    this.api_base_url = this.$route.query.api_base_url && this.$route.query.api_base_url !== '' 
                      ? atob(this.$route.query.api_base_url) 
                      : '';
    if (this.api_base_url && !this.api_base_url.endsWith('/')) {
      this.api_base_url += '/';
    }
    if(this.token||this.token!='') {
      await this.fetchTheReport();
    }
    // #1533: intercept the wishlist-summary per-row assign link so it opens the
    // assign step as an in-viewer modal instead of navigating a new tab.
    this.installAssignIntercept();
    await this.onLoadFromFile(this.gcsSignInSheetTemplate);
  },

  beforeDestroy() {
    this.restoreWindowOpen();
  },

  methods: {
    // ── #1533 wishlist-assign hyperlink interception ──────────────────────────
    // ActiveReports navigates a TextBox hyperlink through window.open; wrap it so
    // a "/wishlist-assign" link opens the in-viewer assign modal instead of a tab.
    installAssignIntercept() {
      var self = this;
      this.origWindowOpen = window.open;
      window.open = function (url) {
        if (typeof url === 'string' && url.indexOf('/wishlist-assign') !== -1) {
          var q = url.split('?')[1] || '';
          var params = {};
          q.split('&').forEach(function (pair) {
            var kv = pair.split('=');
            if (kv[0]) params[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1] || '');
          });
          self.openAssignModal(params.job || '', params.employee || '');
          return null; // swallow the navigation — the modal opens in-viewer
        }
        return self.origWindowOpen.apply(window, arguments);
      };
    },
    restoreWindowOpen() {
      if (this.origWindowOpen) {
        window.open = this.origWindowOpen;
        this.origWindowOpen = null;
      }
    },

    // ── #1533 in-viewer assign modal ──────────────────────────────────────────
    // Headers: just the Bearer token already on the report URL. The cs3
    // assign endpoint derives the initiator from the authenticated user and the
    // client from the call's job (the false-conflict fix), so no user_id /
    // context headers are needed here.
    assignHeaders() {
      return { 'Authorization': this.token };
    },
    openAssignModal(job, employee) {
      this.assignJob = job;
      this.assignEmployee = employee;
      this.assignSlots = [];
      this.assignError = '';
      this.assignSuccess = '';
      this.assigningId = null;
      this.assignModalOpen = true;
      if (!job || !employee) {
        this.assignLoading = false;
        this.assignError = 'Missing job or employee reference.';
        return;
      }
      this.loadAssignSlots();
    },
    closeAssignModal() {
      this.assignModalOpen = false;
    },
    loadAssignSlots() {
      var self = this;
      this.assignLoading = true;
      this.assignError = '';
      Vue.axios.get(this.api_base_url + 'job/' + this.assignJob + '/eligible-open-slots/' + this.assignEmployee, {
        headers: this.assignHeaders()
      }).then(function (res) {
        var result = (res.data && res.data.result) || [];
        self.assignSlots = Array.isArray(result) ? result : [];
      }).catch(function (err) {
        console.log(err);
        self.assignError = 'Could not load open slots.';
      }).then(function () {
        self.assignLoading = false;
      });
    },
    assignSlot(slot) {
      if (this.assigningId) return;
      var self = this;
      this.assigningId = slot.id;
      this.assignError = '';
      this.assignSuccess = '';
      Vue.axios.put(this.api_base_url + 'call/' + slot.id + '/assign', {
        employee_id: this.assignEmployee
      }, {
        headers: this.assignHeaders()
      }).then(function (res) {
        // envelope is { status_code, status_message, result }
        var ok = res.data && (res.data.status_code === '1' || res.data.status_code === 1);
        if (ok) {
          self.assignSuccess = 'Assigned. Sent to the phone sheet.';
          // re-fetch so identical-time sibling slots (now double-booked) drop off
          self.loadAssignSlots();
        } else {
          self.assignError = (res.data && res.data.status_message) || 'Could not assign (conflict).';
        }
      }).catch(function (err) {
        var msg = err && err.response && err.response.data && err.response.data.status_message;
        self.assignError = msg || 'Assign failed — please retry.';
      }).then(function () {
        self.assigningId = null;
      });
    },
    formatSlot(slot) {
      var fmt = function (d) {
        if (!d) return '';
        var dt = new Date(String(d).replace(' ', 'T'));
        if (isNaN(dt.getTime())) return d;
        return dt.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
      };
      return fmt(slot.start) + (slot.end ? ' – ' + fmt(slot.end) : '');
    },

    async fetchTheReport() {
      // let url = "https://localhost.dev-callsteward.com/api/v2/reports/signedUrl?url=" + this.dataSource;
      let url = this.api_base_url + "reports/signedUrl?url=" + this.dataSource;
      try {
        let response = await Vue.axios.get(url, {
          headers: {
            'Authorization': this.token,
            'template': this.gcsSignInSheetTemplate,
            'employee_id': this.employee_id
          }
        });
        this.tempReportJsonUrl = response.data.url
      } catch (error) {
        console.error("Error fetching report:", error);
      }
    },
    onViewerLoaded(e) {
      // Access the underlying viewer instance
      console.log(e);
      const viewer = this.$refs.reportViewer.viewer;

      // Remove refresh button from toolbar
      const newToolbar = viewer.toolbar.items.filter(item => item.key !== 'refresh');
      viewer.toolbar.items = newToolbar;

      // OPTIONAL: force update toolbar UI
      viewer.toolbar.update();
    },
    async onLoadFromFile(url) {
      try {
        this.loading = true;
        // console.log(this.loading);
        if (this.dataSource && this.dataSource !== '') {
          let data = await this.loadData();
          await this.getAlienAPI(url).then(res => {
            res.data.DataSources[0].ConnectionProperties.ConnectString = "jsondata=" + JSON.stringify(data);
            this.$refs.reportViewer.Viewer().open(res.data);
          });
        } else {
          await this.getAlienAPI(url).then(res => {
            this.$refs.reportViewer.Viewer().open(res.data);
          });
        }
        this.loading = false;
        // console.log(this.loading);
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    cancelReportDownload() {
      // console.log("Cancel Triggered");
      return false;
    },

    // downloadReportBlob(reportData) {
      // not in use for viewr.downlad() functionality in the report download
      // const blob = new Blob([reportData], { type: 'application/pdf' });
      // Trigger download
      // saveAs(blob, 'EmployeeReport.pdf'); 
      // const link = document.createElement('a');
      // link.href = URL.createObjectURL(blob);
      // link.download = 'EmployeeReport.pdf'; // Specify filename
      // link.click(); 

      // Cleanup
      // URL.revokeObjectURL(link.href);  // Release the object URL
      // link.remove();  // Remove the link element from the DOM
    // },

    // async downloadReport() {
      // console.log("Download Button Triggered");
      // const viewer = this.$refs.reportViewer.Viewer();
      // viewer.export('pdf', this.exportsSettings.pdf, {cancel: this.cancelReportDownload() }).then(result => this.downloadReportBlob(result.data));
      // viewer.export('pdf', this.exportsSettings.pdf, {cancel: this.cancelReportDownload() }).then(result => result.download('EmployeeReport'));
    // },

    async getAlienAPI(url) {
      return await new Promise((resolve, reject) => {
        Vue.axios.get(url).then(response => resolve(response)).catch(error => reject(error));
      });
    },

    async loadData() {
      let data = null;
      let dataurl = this.token&&this.token!='' ? this.tempReportJsonUrl : this.dataSource;
      await fetch(dataurl)
        .then(async response => await response.json())
        .then(json => {
          data = json;
        });
      return data;
    },
  },
};
</script>

<style scoped>
button[aria-label="Refresh"] {
  display: none !important;
}
.download-button-section {
  cursor: pointer;
  margin: 15px;
  text-align: center;
}
.download-button-section .downlad-report-button {
  cursor: pointer;
  z-index: 9999;
  background-color: #008f4f;
  color: #fff;
  border-radius: 6px;
  border: none;
  padding: 10px 20px;
  font-weight: bold;
}
/* Add any additional styles here */

/* #1533: in-viewer wishlist-assign modal */
.wla-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 60px 16px;
  z-index: 2147483000;
}
.wla-modal {
  background: #fff;
  width: 440px;
  max-width: 96vw;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 8px;
  box-shadow: 0 6px 28px rgba(0, 0, 0, 0.28);
  padding: 18px 22px 22px;
}
.wla-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.wla-title { font-size: 1.2rem; margin: 0; color: #333; }
.wla-close {
  background: none;
  border: none;
  font-size: 26px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  padding: 0 4px;
}
.wla-error { color: #b00020; background: #fdecef; padding: 10px 12px; border-radius: 4px; margin-bottom: 12px; }
.wla-success { color: #1b7a36; background: #eaf6ee; padding: 10px 12px; border-radius: 4px; margin-bottom: 12px; }
.wla-note { color: #777; padding: 12px 0; }
.wla-slots { list-style: none; margin: 0; padding: 0; }
.wla-slot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}
.wla-slotinfo { display: flex; flex-direction: column; }
.wla-slotinfo em { color: #888; font-style: normal; font-size: 0.85em; margin-top: 2px; }
.wla-btn {
  background: #2a6ebd;
  color: #fff;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
}
.wla-btn.is-busy { opacity: 0.6; pointer-events: none; }
</style>